export var BoardIncludes = {
    organizations: true,
    reportToBoards: {
        include: {
            report: true,
        },
    },
};
//# sourceMappingURL=Board.js.map